import React from "react";
import { Formik, FormikProps } from "formik";
import { IManagementStore, ISelectItem } from "Stores/Management/types";
import { Values } from "Tools/Values";
import { LocationPosition } from "@src/Interfaces/Entity/Location";
import { Position } from "@src/Interfaces/Entity/Position";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import {STFormSimpleSelect} from "./styles";
import AddIcon from "@material-ui/icons/Add";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import * as Yup from "yup";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import { ButtonsForm } from "@src/Components/Common/ButtonsForm/ButtonsForm";
import _ from "lodash";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  locationPositions: LocationPosition[];
  values?: IValuesStore;
  management?: IManagementStore;
  onAdd: (positionId: string) => void;
}

interface IPositionSelect {
  position: string;
}

const schema = Yup.object().shape({
  position: Yup.string().required(() => {
    return Values.getLocalizationValue("fieldRequired");
  }),
});

@inject("values", "management")
@observer
export default class AddPosition extends React.Component<IProps> {
  @observable opened: boolean = false;

  getPositions(): Position[] {
    let items = _(this.props.management.activePositions)
      .filter(p => !this.props.locationPositions.find(position => position.positionId == p.id
        && position.state === this.props.values.states.Active))
      .orderBy(p => p.name)
      .value();
    return items;
  }

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  onAdd = (data: IPositionSelect) => {
    let positionId = data.position;
    this.props.onAdd(positionId);
    this.handleClose();
  };

  render() {
    const positionSelect: IPositionSelect = { position: "" };
    let positions = this.getPositions();
    return (
      <div>
          <RoundButton 
              icon={<AddIcon/>}
              tooltipTitle={Values.getLocalizationValue("addPosition")}
              onClick={() => this.handleOpen()}
              color={"gray"}
          />
          
        <SimpleModal
          width={500}
          isOpened={this.opened}
          onClose={this.handleClose}
        >
          <Formik
            initialValues={positionSelect}
            validationSchema={schema}
            onSubmit={this.onAdd}
            render={(formikProps: FormikProps<IPositionSelect>) => (
              <STFormWrapper onSubmit={formikProps.handleSubmit}>
                <STFormTitleTypography>
                  {Values.getLocalizationValue("selectPosition")}
                </STFormTitleTypography>
                <STFormSimpleSelect<IPositionSelect, ISelectItem>
                  fieldName="position"
                  items={positions}
                  keyAsTitle="title"
                  keyAsValue="id"
                  keyAsDescription="name"
                  formikProps={formikProps}
                  label={Values.getLocalizationValue("position")}
                />
                <ButtonsForm
                  onSubmit={formikProps.handleSubmit}
                  onClose={this.handleClose}
                />
              </STFormWrapper>
            )}
          />
        </SimpleModal>
      </div>
    );
  }
}
